import React from 'react'
import MyAccount from '../../components/Account/MyAccount'

const MyAccountPage = () => {
  return (
    <div>
        <MyAccount />
    </div>
  )
}

export default MyAccountPage